import it from './home.it.json';
import en from './home.en.json';

const homeContent = { it, en };

export default homeContent;
